import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({isAuthenticated, component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        if (!isAuthenticated) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        }

        // authorized so return component
        return <Component {...props} />
    }} />
)

export default PrivateRoute;